import axios from "axios";
import { clientVitalsAPI } from "../secrets";
import { PaymentMethod } from "@stripe/stripe-js";

export const fetchCustomerPaymentMethod = async (customerId: string) => {
   try {
    if (!customerId) return;
    
    const result: Record<any, any> = await axios.get(`${clientVitalsAPI}/stripe/payments/method/${customerId}`);

    return result?.data;
  } catch (error) {
    throw error;
  } 
}

export const updatePaymentMethod = async (customerId: string, paymentMethodId: string | PaymentMethod) => {
  try {
    if (!customerId || !paymentMethodId) return;
    
    const result: Record<any, any> = await axios.post(`${clientVitalsAPI}/stripe/payments/method/update`, {
      customerId, paymentMethodId
    });

    return result?.data;
  } catch (error) {
    throw error;
  }
};

export const createPaymentIntent = async (customerId: string, productId: string, discount?: number) => {
  try {
    if (!customerId || !productId) return;
    
    const result: Record<any, any> = await axios.post(`${clientVitalsAPI}/stripe/payments/create-pi`, {
      customerId, productId, discount
    });

    return result?.data;
  } catch (error) {
    throw error;
  }
};

export const createGuestPaymentIntent = async (productId: string) => {
  console.log({ productId })
  try {
    if (!productId) return;
    
    const result: Record<any, any> = await axios.post(`${clientVitalsAPI}/stripe/payments/create-pi`, {
      productId
    });
    console.log({response: result})
    return result?.data;
  } catch (error) {
    throw error;
  }
};

export const updatePaymentIntent = async (paymentIntentId: string, newAmount: number) => {
  try {
    if (!paymentIntentId || !newAmount) return;

    const result: Record<any, any> = await axios.post(`${clientVitalsAPI}/stripe/payments/update-pi`, {
      paymentIntentId, newAmount
    });

    return result?.data;
  } catch (error) {
    throw error;
  }
};

export const createSetupIntent = async (customerId: string) => {
  try {
    if (!customerId) return;
    
    const result: Record<any, any> = await axios.post(`${clientVitalsAPI}/stripe/payments/create-si`, {
      customerId
    });

    return result?.data;
  } catch (error) {
    throw error;
  }
};

export const validateCouponCode = async (code: string) => {
  try {
    if (!code) return false;

    const result: Record<any, any> = await axios.post(`${clientVitalsAPI}/stripe/payments/validate-coupon`, { code });

    return result?.data;
  } catch (error) {
    throw error;
  }
};

export const applyCouponCode = async (code: string) => {
  try {
    if (!code) return false;

    const result: Record<any, any> = await axios.post(`${clientVitalsAPI}/stripe/payments/apply-coupon`, { code });

    return result?.data?.applied;
  } catch (error) {
    throw error;
  }
};

export const createCreateGuestCustomer = async () => {
  try {
   const result: Record<any, any> = await axios.post(`${clientVitalsAPI}/stripe/payments/create-guest-customer`);

    return result?.data;
  } catch (error) {
    throw error;
  }
};

export const createSetupIntentForSubscription = async (customerId: string) => {
    try {
    if (!customerId) return;
    
    const result: Record<any, any> = await axios.post(`${clientVitalsAPI}/stripe/payments/create-setup-intent`, {
      customerId
    });

    return result?.data;
  } catch (error) {
    throw error;
  }
}

export const subscribeUser = async (customerId: string, priceId: string, paymentMethodId: string) => {
    try {
    if (!customerId || !priceId || !paymentMethodId) return;
    
    const result: Record<any, any> = await axios.post(`${clientVitalsAPI}/stripe/payments/subscribe`, {
        customerId,
        priceId,
        paymentMethodId, // send it!
      });

    return result?.data;
  } catch (error) {
    throw error;
  }
}